import { DashboardService, ImageService } from '@/services';

import { NOTI_TYPES } from '@/store/dashboardEdit';
import { ADD_NOTI } from './newDashboard';

export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        setNotepadWidgetsEditingActiveStatus(state, payload) {
            const { widgetId, flag, reset } = payload;

            if (reset) {
                state.notepadWidgetsEditingActiveStatus = {};
                return;
            }

            state.notepadWidgetsEditingActiveStatus = {
                [widgetId]: flag,
            };
        },
        setNotepadWidgetsContent(state, payload) {
            const { widgetId, content, reset = false } = payload;

            if (reset) {
                state.notepadWidgetsContent = {};
                return;
            }

            state.notepadWidgetsContent = R.assocPath(
                [widgetId, 'content'],
                content
            )(state.notepadWidgetsContent);
        },
        setNotepadWidgetSaveProgress(state, payload) {
            state.notepadWidgetSaveProgress = payload;
        },
        setNotepadWidgetIsSaving(state, payload) {
            state.notepadWidgetIsSaving = payload;
        },
    },
    actions: {
        uploadNotepadImage({ commit, state, rootState, rootGetters }, payload) {
            const { file } = payload;

            const formData = new FormData();
            formData.append('files', file);

            return ImageService.uploadMyFile({
                type: 'media',
                formData,
                params: {
                    isPublic: 0,
                    isNotepad: true,
                },
            }).catch(() =>
                commit(ADD_NOTI, { type: NOTI_TYPES.FAIL }, { root: true })
            );
        },
        getNotepadWidget({ commit, state }, payload) {
            const { viewId, widgetId } = payload;

            return DashboardService.getNotepadWidgetData({
                viewId,
                widgetId,
            }).then((data) => {
                // commit('setNotepadWidgetsContent', {
                //     widgetId,
                //     content: R.prop('content', data),
                // });
                return data;
            });
        },
        updateNotepadWidget({ commit, state }, payload) {
            const { viewId, widgetId, content } = payload;

            return DashboardService.updateNotepadWidgetData({
                viewId,
                widgetId,
                content,
            })
                .then((data) => {
                    // commit('setNotepadWidgetsContent', {
                    //     widgetId,
                    //     content,
                    // });
                    commit(
                        ADD_NOTI,
                        { type: NOTI_TYPES.SUCCESS },
                        { root: true }
                    );

                    return data;
                })
                .catch((err) => {
                    commit(ADD_NOTI, { type: NOTI_TYPES.FAIL }, { root: true });
                    console.log('updateNotepadWidget:: error: ', err);
                });
        },
    },
    getters: {},
};

function getDefaultState() {
    return {
        notepadWidgetsEditingActiveStatus: {}, // which notepadWidget is in editing mode
        notepadWidgetsContent: {}, // to refer when duplicating an widget
        // notepadWidgetSaveProgress: 0, // to control save progress bar percentage
        // notepadWidgetIsSaving: false, // to show/hide save progress bar on the top
    };
}
